import mailData from './mailData.js';

const outLeadsProfiles = [
  {
    "id": 1,
    "profileImgPath": "/images/OurTeam/Ambrish.png",
    "name": "Ambrish Rastogi",
    "details": "Managing Director, Lead - Learning and Talent Transformation Advanced Technology Centers in India",
    "profileLink": "https://wd103.myworkday.com/accenture/d/inst/autocompletesearch/247$2095224.htmld#TABTASKID=2998%2440311",
    "linkdIn": "",
    "mailTo": mailData.leadAmbrish
  },
  {
    "id": 2,
    "profileImgPath": "/images/OurTeam/Anirudh.png",
    "name": "Anirudh Goel",
    "details": "Strategic Initiatives, AI, Innovation, Custom Engg",
    "profileLink": "https://wd103.myworkday.com/accenture/d/inst/1$247/247$886256.htmld#TABTASKID=2998%2440311",
    "linkdIn": "",
    "mailTo": mailData.leadAnirudh
  },
  {
    "id": 3,
    "profileImgPath": "/images/OurTeam/Abhilash.png",
    "name": "Abhilash D Bungale",
    "details": "Program & Project Mgmt Manager",
    "profileLink": "https://wd103.myworkday.com/accenture/d/inst/1$247/247$1371161.htmld#TABTASKID=2998%2440311",
    "linkdIn": "",
    "mailTo": mailData.leadAbhilash
  },
  {
    "id": 4,
    "profileImgPath": "/images/OurTeam/Shruthi.png",
    "name": "Shruti Aggarwal",
    "details": "Tech Writing & Translation Assoc Manager",
    "profileLink": "https://wd103.myworkday.com/accenture/d/inst/1$247/247$740853.htmld#TABTASKID=2998%2440311",
    "linkdIn": "",
    "mailTo": mailData.leadShruti
  }
]

export default outLeadsProfiles;